import api from 'api';
import ApiService from 'api/ApiService';
import {DialogTypes} from 'common/names';
import {layoutActions} from 'features/layout/redux';
import {ICloseSubDialogAction} from 'features/layout/redux/actions';
import i18n from 'i18n';
import {call, delay, put, race} from 'redux-saga/effects';
import {asyncSagaConstructor} from 'redux/common';
import {openDialogWithResult} from 'redux/common/saga/openDialogWithResult';
import {takeDialogResult} from 'redux/common/saga/takeDialogResult';
import {IBooleanResult} from 'types/diplomat/BooleanResult';
import {settingsTypes} from '..';

/**
 *
 * @returns false if archiving isn't in progress or been stopped, true otherwise
 */
export function* auditArchiveRunning() {
   const res = (yield call(
      asyncSagaConstructor(api.archiveStatus, settingsTypes.GET_AUDIT_ARCHIVE_STATUS)
   )) as IBooleanResult;

   // archiving is not in progress
   if (!res.result) {
      return false;
   }

   const dialogResult: ICloseSubDialogAction<boolean> = yield call(openDialogWithResult, {
      id: DialogTypes.ConfirmDialog.id,
      data: {
         title: i18n.t('Cannot proceed because an audit archive is in progress.'),
         content: i18n.t('Do you want to stop the audit archive process?'),
      },
   });
   const cancelArchiving = dialogResult.payload!.data!;

   if (cancelArchiving) {
      const isCancelled = (yield call(startCancellingProcess)) as ReturnType<
         typeof startCancellingProcess
      >;
      return !isCancelled;
   }
   return false;
}

function* startCancellingProcess() {
   yield put(
      layoutActions.openSubDialog({
         id: DialogTypes.StatusDialog.id,
         data: {
            title: i18n.t('Audit Archiver'),
         },
      })
   );

   const [, isCancelled] = (yield race([
      call(takeDialogResult, DialogTypes.StatusDialog.id),
      call(cancelArchiving),
   ])) as [any, boolean];

   return isCancelled;
}

function* cancelArchiving() {
   const lines = [i18n.t('Stopping...')];
   let buttonLabel = i18n.t('Cancel');
   yield put(layoutActions.setActiveDialogStatus(lines, buttonLabel));

   yield call(
      asyncSagaConstructor(api.cancelArchiving, settingsTypes.CANCEL_ARCHIVING, {
         getMethod: ApiService.postSecureJson,
      })
   );

   let archiveStatus;
   do {
      yield delay(1000);
      archiveStatus = (yield call(
         asyncSagaConstructor(api.archiveStatus, settingsTypes.GET_AUDIT_ARCHIVE_STATUS)
      )) as IBooleanResult;
   } while (!archiveStatus.result);

   lines[0] = i18n.t('Stopped');
   buttonLabel = i18n.t('Ok');
   yield put(layoutActions.setActiveDialogStatus(lines, buttonLabel));

   return true;
}
